import Fetcher from '../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../constants'
import { PaymentStatusList, PaymentStatusRequest } from './types'
import { TAdminDocumentData } from './AdminTable/types'
import { LedByUnion } from '../../ContractCategoryDetails/types'

const fetcher = new Fetcher({})

export const getARPaymentStatusData = async (data) =>
  fetcher.request<PaymentStatusRequest, PaymentStatusList>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.ACCOUNTS_RECEIVABLE}${API_DICTIONARY.PAYMENT_BY_STATUS}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getAPPaymentStatusData = async (data) =>
  fetcher.request<PaymentStatusRequest, PaymentStatusList>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.ACCOUNTS_PAYABLE}${API_DICTIONARY.PAYMENT_BY_STATUS}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getAdminTableDocumentInfo = async (
  monthId: string,
  isInvoices: boolean,
  selectedLedBy?: LedByUnion
) =>
  fetcher.request<unknown, TAdminDocumentData>({
    url: `${API_DICTIONARY.FINANCES}${
      API_DICTIONARY.ADMIN_FEE_DASHBOARD
    }${monthId}/${
      isInvoices ? API_DICTIONARY.INVOICE : API_DICTIONARY.REMIT_ADVICE
    }`,
    method: HTTP_METHODS.GET,
    params: selectedLedBy
      ? {
          recipient: selectedLedBy
        }
      : undefined
  })
